import gql from 'graphql-tag'

export const CREATE_REVIEW_FEEDBACK_FORM = gql`
  mutation CreateReviewFormFeedback($data: ReviewFormFeedbackInput) {
    createReviewFormFeedback(data: $data) {
      id
      ClientCode
      UserName
      Email
      clientName
      phone
      SubmitDate
      Response
      Suggestion
    }
  }
`
